var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreenTickThin = function SvgGreenTickThin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.4,
    height: 34.398,
    viewBox: "0 0 33.4 34.398",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(4.281 16.7) rotate(13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M54.918,36.887a1.675,1.675,0,0,0-1.139.637L40.528,60.762l-7.612-5.53a1.643,1.643,0,0,0-2.4.069,1.832,1.832,0,0,0,.066,2.507l8.909,6.8a1.652,1.652,0,0,0,1.26.487,1.669,1.669,0,0,0,1.2-.625L56.374,39.823a1.838,1.838,0,0,0,.234-1.991A1.679,1.679,0,0,0,54.918,36.887Z",
    transform: "translate(-31.171 -53.294)",
    fill: "#23c373",
    stroke: "#23c373",
    strokeWidth: 0.7
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenTickThin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/greenTickThin.930b030f.svg";
export { ForwardRef as ReactComponent };